import { IonItem, IonLabel, IonList } from '@ionic/react';
import { Certification } from '@/types/certification';

interface CoursesNavProps {
  certifications: Certification[];
  selectedCertificationId: string | null;
  selectedCategory: string;
  onSelect: (certificationId: string, category: string) => void;
  isOpen?: boolean;
  onClose?: () => void;
}

export const CoursesNav: React.FC<CoursesNavProps> = ({ certifications, selectedCertificationId, selectedCategory, onSelect, isOpen = false, onClose }) => {

  return (
    <>
      {/* Overlay for mobile drawer */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar - static on lg+, drawer on smaller screens */}
      <aside
        data-tour="course-category-filter"
        className={`
        fixed lg:static top-0 left-0 h-full
        w-[300px] min-w-[300px] flex-shrink-0
        bg-white border-r border-gray-200 p-4
        transition-transform duration-300 ease-in-out
        z-50 lg:z-auto
        overflow-y-auto
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        lg:translate-x-0
      `}>
        <h2 className="text-lg font-bold mb-4">Certifications</h2>

{certifications.length === 0 ? (
          <p className="text-gray-500 text-sm">No certifications available</p>
        ) : (
          <div className="space-y-6">
            {certifications.map((cert, index) => {
              const totalCourses = cert.courseCategories.reduce(
                (sum, category) => sum + category.courses.length,
                0
              );
              return (
                <div key={cert.id} className={index > 0 ? 'border-t-2 border-primary pt-2' : ''}>
                  <div className="mb-2">
                    <h3 className="font-semibold text-base mb-1">{cert.name}</h3>
                    <p className="text-gray-600 text-sm mb-1">Issuer: {cert.issuer}</p>
                    <p className="text-gray-500 text-xs">
                      {totalCourses} {totalCourses === 1 ? 'Course' : 'Courses'}
                    </p>
                  </div>
                  <div className='mt-3 color-tertiary font-semibold border-b border-gray-300 pb-1'>
                    Categories
                  </div>

                  <IonList className="ion-no-padding">
                    <IonItem
                      button
                      lines="none"
                      onClick={() => {
                        onSelect(cert.id, 'all');
                        onClose?.();
                      }}
                      className={`cursor-pointer ${
                        selectedCertificationId === cert.id && selectedCategory === 'all' ? 'text-primary' : ''
                      }`}
                      style={{
                        '--background': selectedCertificationId === cert.id && selectedCategory === 'all' ? '#FCEEF0' : 'transparent',
                        '--color': selectedCertificationId === cert.id && selectedCategory === 'all' ? 'var(--ion-color-primary)' : 'inherit',
                      }}
                    >
                      <IonLabel>All Courses</IonLabel>
                    </IonItem>

                    {cert.courseCategories
                      .sort((a, b) => a.order - b.order)
                      .map((category) => (
                        <IonItem
                          key={category.category}
                          button
                          lines="none"
                          onClick={() => {
                            onSelect(cert.id, category.category);
                            onClose?.();
                          }}
                          className={`cursor-pointer ${
                            selectedCertificationId === cert.id && selectedCategory === category.category ? 'text-primary' : ''
                          }`}
                          style={{
                            '--background': selectedCertificationId === cert.id && selectedCategory === category.category ? '#FCEEF0' : 'transparent',
                            '--color': selectedCertificationId === cert.id && selectedCategory === category.category ? 'var(--ion-color-primary)' : 'inherit',
                          }}
                        >
                          <IonLabel>{category.category}</IonLabel>
                        </IonItem>
                      ))}
                  </IonList>
                </div>
              );
            })}
          </div>
        )}
      </aside>
    </>
  );
};
